import script from "./work.vue?vue&type=script&setup=true&lang=js"
export * from "./work.vue?vue&type=script&setup=true&lang=js"

import "./work.vue?vue&type=style&index=0&id=73ac0b3c&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ac0b3c"]])

export default __exports__